<template>
  <b-modal
  class="cancellationModal" id="cancellationModal"
  size="xl"
  scrollable
  button-size="sm"
  centered
  hide-header-close
  no-close-on-backdrop>

  <template #modal-header>
    <h3>Cancel Order</h3>
  </template>

  <span>Add Cancellation Reason</span>
  <b-form-textarea v-model="cancellationNoteText"
    class="mt-2"
    no-close-on-backdrop
    rows="3"
    max-rows="8"
    placeholder="Enter a cancellation reason...">
  </b-form-textarea>

  <hr class="mt-4" />

  <div class="mt-4">
    <p>Return Items To Inventory</p>
    <div class="mb-2">
      <b-button class="mr-2" variant="outline-secondary" size="sm" @click="selectAllRows"><b-icon-list-check></b-icon-list-check> Select all</b-button>
      <b-button variant="outline-secondary" size="sm" @click="clearSelected"><b-icon-list></b-icon-list> Clear selected</b-button></div>
    <b-table
      class="pb-10"
      ref="returnToInventoryTable"
      selectable
      small
      @row-selected="onRowSelected"
      :items="items"
      :fields="fields">

      <template #cell(title)="data">
        <span v-if="data.item.title !== data.item.currentListing.title" class="warn" :id="'titleWarning-' + data.item.id">
          {{ data.item.title }}
          <b-tooltip :target="'titleWarning-' + data.item.id" triggers="hover" placement="bottom">
            Current title: {{ data.item.currentListing.title }}
          </b-tooltip>
        </span>
        <span v-else>
          {{ data.item.title }}
        </span>
      </template>

      <template #cell(artist)="data">
        <span v-if="data.item.artist !== data.item.currentListing.artist" class="warn" :id="'artistWarning-' + data.item.id">
          {{ data.item.artist }}
          <b-tooltip :target="'artistWarning-' + data.item.id" triggers="hover" placement="bottom">
            Current artist: {{ data.item.currentListing.artist }}
          </b-tooltip>
        </span>
        <span v-else>
          {{ data.item.artist }}
        </span>
      </template>

      <template #cell(label)="data">
        <span v-if="data.item.label !== data.item.currentListing.label" class="warn" :id="'labelWarning-' + data.item.id">
          {{ data.item.label }}
          <b-tooltip :target="'labelWarning-' + data.item.id" triggers="hover" placement="bottom">
            Current label: {{ data.item.currentListing.label }}
          </b-tooltip>
        </span>
        <span v-else>
          {{ data.item.label }}
        </span>
      </template>

      <template #cell(format)="data">
        <span v-if="data.item.format !== data.item.currentListing.format" class="warn" :id="'formatWarning-' + data.item.id">
          {{ data.item.format }}
          <b-tooltip :target="'formatWarning-' + data.item.id" triggers="hover" placement="bottom">
            Current format: {{ data.item.currentListing.format }}
          </b-tooltip>
        </span>
        <span v-else>
          {{ data.item.format }}
        </span>
      </template>

      <template #cell(price)="data">
        <span v-if="data.item.price !== data.item.currentListing.price" class="warn" :id="'priceWarning-' + data.item.id">
          ${{ data.item.price }}
          <b-tooltip :target="'priceWarning-' + data.item.id" triggers="hover" placement="bottom">
            Current price: ${{ data.item.currentListing.price }}
          </b-tooltip>
        </span>
        <span v-else>
          ${{ data.item.price }}
        </span>
      </template>
      <template #cell(grade)="data">
        <span v-if="data.item.grade !== data.item.currentListing.grade" class="warn" :id="'gradeWarning-' + data.item.id">
          {{ data.item.grade }}
          <b-tooltip :target="'gradeWarning-' + data.item.id" triggers="hover" placement="bottom">
            Current grade: {{ data.item.currentListing.grade }}
          </b-tooltip>
        </span>
        <span v-else>
          {{ data.item.grade }}
        </span>
      </template>
      <template #cell(source)="data">
        <span v-if="data.item.source !== data.item.currentListing.source && data.item.currentListing.source !== 'none'" class="warn" :id="'sourceWarning-' + data.item.id">
          {{ data.item.source }}
          <b-tooltip :target="'sourceWarning-' + data.item.id" triggers="hover" placement="bottom">
            Current source: {{ data.item.currentListing.source }}
          </b-tooltip>
        </span>
        <span v-else>
          {{ data.item.source }}
        </span>
      </template>
      <template #cell(location)="data">
        <span v-if="data.item.location !== data.item.currentListing.location" class="warn" :id="'locationWarning-' + data.item.id">
          {{ data.item.location }}
          <b-tooltip :target="'locationWarning-' + data.item.id" triggers="hover" placement="bottom">
            Current location: {{ data.item.currentListing.location }}
          </b-tooltip>
        </span>
        <span v-else>
          {{ data.item.location }}
        </span>
      </template>
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>

  </div>
  <template #modal-footer="{  }">
    <b-button v-if="!cancelling" size="sm" class="mb-0 mt-3" @click="saveAndClose" variant="success">
      <b-icon-check-square-fill></b-icon-check-square-fill>
        <span class="p-xl-2 pl-2 pr-1">Cancel Order</span>
    </b-button>
    <b-button size="sm" v-else variant="success" class="mb-0 mt-3" @click="saveAndClose" :disabled="true">
      <b-spinner small variant='light' class="mr-1"></b-spinner>Cancelling...</b-button>
    <b-button size="sm" class="mb-0 mt-3" @click="hideCancellationModal" variant="secondary">
     <b-icon-x-square-fill></b-icon-x-square-fill>
        <span class="p-xl-2 pl-2 pr-1">Discard</span>
    </b-button>
  </template>
  </b-modal>
</template>

<script>
import ordersApi from "../../api/orders";
import inventoryApi from "../../api/inventory";
import moment from "moment";
import OrderItemMixin from "../../builders/orderItem";
import itemMixin from "../../mixins/item";


export default {
  name: "CancellationModal",
  mixins: [ OrderItemMixin, inventoryApi, ordersApi, itemMixin ],
  props: [ 'itemsOnOrder', 'newlyCancelled', 'existingNotes', 'orderId' ],

  data() {
      return {
          cancelling: false,
          cancellationNoteText: null,
          selected: [],
          fields: [
              { key: 'id', label: 'Item ID' },
              { key: 'artist', label: 'Artist' },
              { key: 'title', label: 'Title', class: 'title'},
              { key: 'label', label: 'Label'},
              { key: 'format', label: 'Format'},
              { key: 'price', label: "Price"},
              { key: 'grade', label: "Grade"},
              { key: 'quantity', label: 'Qty'},
              { key: 'source', label: 'Source'},
              { key: 'location', label: 'Location'}
            ],
      }
  },
  onMounted() {
    this.selected = [];
  },
  methods: {
    async saveAndClose() {
      this.cancelling = true;
      if (this.cancellationNoteText && this.cancellationNoteText.length > 0) {
        this.addCancellationNote();
      }
      const returnToStockArray = this.selected.map((item)=> {return {id: item.listingId, count: item.quantity, consigner: item.consigner, source: item.source !== 'none' ? item.source : undefined}});
        const updatedItems = this.itemsOnOrder.map((item)=> {
          const isSelected = this.selected.some(e => e.id === item.details.itemId );
          if (item.status) { 
            return item } 
          else {
            return {...item, status: this.generateStatus(item.details.quantity, isSelected)};
          }
        });
      await this.saveItemUpdates(updatedItems);
      await this.returnListingsToStock(returnToStockArray);
      this.cancelling = false;
      this.$emit('saveOrder');
      this.cancellationNoteText = null;
      this.$bvModal.hide('cancellationModal');
    },
    hideCancellationModal() {
      this.cancellationNoteText = null;
      this.$bvModal.hide('cancellationModal')
    },
    addCancellationNote() {
      const noteObj = {
        username: this.$auth.user.nickname,
        date: moment().format(),
        type: 'cancellation',
        text: this.cancellationNoteText,
        };
      const notes = [...this.existingNotes, noteObj];
      this.$emit('updateNotes', notes);
    },
    async saveItemUpdates(items) {
        let promises = [];
        items.filter(Boolean);

        for (let i = 0; i < items.length; i++) {
            if (!items[i]) {
                continue;
            }
            if (items[i].status && items[i].status.type === 'cancelled') {
                promises.push(this.addOrderItemStatus(this.orderId, items[i].details.itemId, items[i].details.listing._id, items[i].status.type, items[i].status.reason, items[i].status.quantity, items[i].status.stockAffected, false));
            }
        }
        await Promise.all(promises);
    },
    async returnListingsToStock(listings) {
        let promises = [];
        // get current listing quantities
        const listingIds = listings.map((listing) => listing.id);
        const currentCounts = await this.getQuantityByListingIds(listingIds);
        listings.forEach(item => {
            const updatedCount = currentCounts.find(el => el.listingId === item.id).count + item.count
            promises.push(this.restockListing(item.id, updatedCount, item.consigner, item.source !== "none" ? item.source : undefined));
        })
        await Promise.all(promises);
    },
    async items() {
      let currentListingPromises = [];
      this.itemsOnOrder.filter((item)=> !item.status).map((item)=> { return item.details.listing._id }).forEach(listingId => currentListingPromises.push(this.getListing(listingId)));
      const currentListings = await Promise.all(currentListingPromises);
      // first filter out any items that have a status
      return this.itemsOnOrder.filter((item)=> !item.status).map((item)=> {
        const label = item.details.release.label ? item.details.release.label.name + " " + item.details.release.label.catalogNo : "";
        const currentItem = currentListings.find(a => item.details.itemId === a.itemId);
        const listing = currentItem.listing.find(a => a._id === item.details.listing._id);
        const currentListingChecks = {
          artist: this.artist(currentItem),
          title: this.title(currentItem),
          label: currentItem.release.label ? currentItem.release.label.name + " " + currentItem.release.label.catalogNo : "",
          format: this.format(currentItem.release.media),
          grade: this.gradeData(listing.condition) || null, 
          price: listing.price || null, 
          source: listing.source || "none",
          location: listing.location,
        }
        return {listingId: item.details.listing._id, id: item.details.itemId, artist: this.artist(item.details), title: this.title(item.details), label: label, format: this.format(item.details.release.media), price: item.details.listing.price, grade: this.gradeData(item.details.listing.condition), quantity: item.details.quantity, consigner: item.details.listing.consigner || null, source: item.details.listing.source || "none", location: item.details.listing.location || "none", currentListing: currentListingChecks }
      }
      )
    },
    onRowSelected(items) {
        this.selected = items
      },
    selectAllRows() {
        this.$refs.returnToInventoryTable.selectAllRows()
      },
    clearSelected() {
        this.$refs.returnToInventoryTable.clearSelected()
      },
    generateStatus(quantity, stockAffected) {
      let date = Date.now();
      let newStatus = {
          type: 'cancelled',
          stockAffected: stockAffected,
          username: this.$auth.user.nickname,
          date: date,
          quantity: quantity,
          reason: "Order cancelled",
        };
      return newStatus;
    },
    gradeData(conditionArray) {
      if (conditionArray.length < 1) return '';
        const sortOrder = ["item", "disc", "cover", "label"];
        const sortedArray = conditionArray.slice().sort((a, b) => sortOrder.indexOf(a.subject) - sortOrder.indexOf(b.subject));
        return sortedArray.map(condition => {return condition.grade}).join(', ');
      },
  },
  watch: {
      newlyCancelled() {
          if (this.newlyCancelled) {
            this.$bvModal.show('cancellationModal');
          }
        }
      }
}

</script>

<style scoped>
  .selected {
    width: 20px;
  }
  .warn {
    color: #dc3545;
  }
</style>
<style>
  .title {
    max-width: 200px;
  }
</style>